import BaseService from "@services/BaseService";

export default class MembershipService extends BaseService {
  entity = "memberships";
}
